import React from 'react';
import { useParams } from 'react-router';
import Spinner from 'react-bootstrap/Spinner';
import ProjectGallery from '../../components/projectGallery';
import Unavailable from '../../components/unavailable';
import { useContent } from '../../content/ContentProvider';

export default function ProjectDetail() {
  const { slug } = useParams();
  const { status, projects } = useContent();

  if (status === 'loading') {
    return (
      <div className="col-12 m-auto d-flex flex-column align-items-center justify-content-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Laster inn prosjekt...</span>
        </Spinner>
      </div>
    );
  }
  if (status === 'error') {
    return <Unavailable />;
  }

  // Hidden, deleted and unknown projects all end here: they are simply not
  // in the published content.
  const project = projects.find((p) => p.slug === slug);
  if (!project) {
    return <div>Prosjekt ikke funnet</div>;
  }

  return <ProjectGallery images={project.images} />;
}
